import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer'>
        <p>&#169; 2022 projectwork! right reserved Shlok Singh</p>
        <p>Privacy . Terms . Sitemap </p>
    </div>
  )
}

export default Footer;